import { createSlice } from '@reduxjs/toolkit';
import { Shop } from '../../../page-builder/interface/storeInterface';

export interface StoreState {
  storeData: Shop;
  currentWidth: number;
}

const initialState: StoreState = {
  storeData: {
    CheckoutURL: '',
    CustomerServiceNumber: '',
    CustomerServiceEmail: '',
    MetaPixelID: '',
    Name: '',
    PaymentGateway: '',
    PublicPaymentToken: '',
    ShopID: '',
    StoreID: '',
    ShopURL: '',
    DomainURL: '',
    StoreDescription: '',
    CustomerReviews: [
      {
        id: 0,
        name: '',
        review: '',
      },
    ],
    Timer: {
      interval: 0,
      saleText: '',
      bodyText: '',
    },
    IsCardEncryption: false,
    InBoundRouteId: '',
    CardEncryptionVaultId: '',
    EnableClubOrder: false,
    IndependentTransactionForUpsellPages: false,
    PaypalClientId: '',
    PaypalClientSecret: '',
  },
  currentWidth: 0,
};

export const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setStoreData(state, action) {
      return { ...state, storeData: action.payload };
    },
    setCurrentWidth: (state, action) => {
      return { ...state, currentWidth: action.payload };
    },
  },
});

export const { setStoreData, setCurrentWidth } = storeSlice.actions;

export default storeSlice.reducer;
